import React from 'react';
import classNames from 'classnames';

import './TreeDummyLoading.css';

interface TreeDummyLoadingProps {
  itemCount?: number;
  className?: string;
  showIcons?: boolean;
}

export const TreeDummyLoading = ({
  itemCount = 8,
  className,
  showIcons = true
}: TreeDummyLoadingProps) => {
  const generateItems = () => {
    const items = [];
    
    for (let i = 0; i < itemCount; i++) {
      const isNested = i > 2 && Math.random() > 0.7; // Some items are nested
      const width = Math.random() * 40 + 60; // Random width between 60-100%
      
      items.push(
        <div 
          key={i} 
          className={classNames(
            'tree-dummy-item',
            { 'tree-dummy-item--nested': isNested }
          )}
        >
          {showIcons && (
            <div className="tree-dummy-item__icon" />
          )}
          <div 
            className="tree-dummy-item__text"
            style={{ width: `${width}%` }}
          />
        </div>
      );
    }
    
    return items;
  };

  return (
    <div className={classNames('tree-dummy-loading', className)}>
      {generateItems()}
    </div>
  );
};